<template>
    <!-- Contact section start -->
	<section id="contact-section" class="px-12 lg:px-32 py-16 relative mt-24">
        <!-- Main text start -->
		<h1 class="uppercase text-5xl mb-4 font-semibold ">
			Contact us
		</h1>
		<!-- Main text end -->

        <!-- Form start -->
        <form 
            name="contact" 
            method="POST" 
            data-netlify="true" 
            @submit.prevent="submitForm"
            class="flex justify-center w-full"
        >
            <input type="hidden" name="form-name" value="contact" />
            <div class="flex flex-col w-full items-center max-w-4xl">
                <!-- Success Message -->
                <div v-if="formStatus === 'success'" class="w-full xl:w-4/5 mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
                    {{ $t('contact.successMessage') || 'Message sent successfully! We\'ll get back to you soon.' }}
                </div>
                
                <!-- Error Message -->
                <div v-if="formStatus === 'error'" class="w-full xl:w-4/5 mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
                    {{ errorMessage }}
                </div>

                <label for="user_email" class="text-stone-500 text-left w-full xl:w-4/5">E-mail address</label>
                <input 
                    type="email" 
                    name="email" 
                    id="user_email" 
                    v-model="formData.email"
                    :disabled="formStatus === 'loading'"
                    required
                    class="bg-stone-200 py-2 px-4 w-full mb-6 xl:w-4/5 disabled:opacity-50"
                >

                <label for="user_message" class="text-stone-500 text-left w-full xl:w-4/5">Message</label>
                <textarea 
                    name="message" 
                    id="user_message" 
                    v-model="formData.message"
                    :disabled="formStatus === 'loading'"
                    required
                    cols="30" 
                    rows="10" 
                    class="bg-stone-200 py-2 px-4 w-full mb-6 xl:w-4/5 disabled:opacity-50"
                ></textarea>

                <button 
                    type="submit"
                    :disabled="formStatus === 'loading'"
                    class="btn w-full md:w-1/2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center" 
                    style="color: white;"
                >
                    <span v-if="formStatus === 'loading'" class="mr-2">
                        <i class="fa-solid fa-spinner fa-spin"></i>
                    </span>
                    {{ formStatus === 'loading' ? 'Sending...' : 'Send' }}
                </button>
            </div>
        </form>
        <!-- Form end -->

        <!-- Circle start -->
        <div class="bg-neutral-200 h-44 w-44 md:h-52 md:w-52 rounded-full absolute -top-20 left-0 mt-16 -z-20"></div>
        <!-- Circle end -->
	</section>
	<!-- Contact section end -->
</template>

<script>
export default {
    data() {
        return {
            formData: {
                email: '',
                message: ''
            },
            formStatus: '', // '', 'loading', 'success', 'error'
            errorMessage: ''
        }
    },
    methods: {
        async submitForm() {
            this.formStatus = 'loading';
            this.errorMessage = '';
            
            try {
                // Create form data
                const formData = new FormData();
                formData.append('form-name', 'contact');
                formData.append('email', this.formData.email);
                formData.append('message', this.formData.message);
                
                // Submit to Netlify
                const response = await fetch('/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData).toString()
                });
                
                if (response.ok) {
                    this.formStatus = 'success';
                    // Reset form
                    this.formData.email = '';
                    this.formData.message = '';
                    
                    // Hide success message after 5 seconds
                    setTimeout(() => {
                        this.formStatus = '';
                    }, 5000);
                } else {
                    throw new Error('Form submission failed');
                }
            } catch (error) {
                this.formStatus = 'error';
                this.errorMessage = this.$t('contact.errorMessage') || 'There was an error sending your message. Please try again.';
                
                // Hide error message after 5 seconds
                setTimeout(() => {
                    this.formStatus = '';
                    this.errorMessage = '';
                }, 5000);
            }
        }
    }
}
</script>

<style>

</style>